import React from "react";

import Diamond from "../../../Assets/images/diamond.png";

/** The GEM logo icon used on the login page. */
const DiamondIcon: React.FC = () => <img style={{ width: "6rem" }} src={Diamond} alt="GEM" />;

export default DiamondIcon;
